import Rest from '../Rest'

export default class EmailService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/emails'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
